export default __webpack_public_path__ + "static/media/number-8.d4fba028.svg";